module.exports = "<div class=\"row restrict-view-component\">\r\n  <div class=\"col-12 m-auto p-auto\">\r\n    <h5 class=\"text-center\">{{ 'HOME.AUTHORIZATION.MESSAGE.'+message | translate }}</h5>\r\n    <h5 class=\"text-center\" *ngIf=\"showContactDetails\">\r\n      <div [innerHTML]=\"contactDetails\"></div>\r\n   </h5>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/authorization/authorization.component.html
// module id = ../../../../../src/app/authorization/authorization.component.html
// module chunks = main